import { combineReducers } from "redux";

// Front
import Layout from "./layouts/reducer";
import Loading from "./loading/reducer";

const rootReducer = combineReducers({
    // public
    Layout,
    Loading,
});

export default rootReducer;